<div *ngIf="isRunning" style="height:auto">
  <div class="analyzing-container">
    <img src="assets/shield-pulsar-logo.png" alt="Logo" class="analyzing-logo" />
    <br>
    <div class="spinner spinner-1">
      <span class="analyzing-label">{{ waitService.message }}</span>
    </div>
  </div>
  <div>
    <ng-container *ngTemplateOutlet="version"></ng-container>
  </div>
</div>
<div class="dim-background" *ngIf="menuOpen" (click)="toggleMenu()"></div>

<!-- Burger Icon -->
<div class="sticky-top" *ngIf="!isRunning && !showError">

  <div class="custom-tab-bar">
    <button
      [class.active]="selectedTabIndex === TabIndexEnum.OVERVIEW"
      (click)="selectTab(TabIndexEnum.OVERVIEW)">
      <i class="ms-Icon ms-Icon--Tiles"></i>
      <span>{{ 'overview.overview' | translate }}</span>
      <div class="active-indicator" *ngIf="selectedTabIndex === TabIndexEnum.OVERVIEW"></div>
    </button>
    <button
      [class.active]="selectedTabIndex === TabIndexEnum.SENDER"
      (click)="selectTab(TabIndexEnum.SENDER)">
      <i class="ms-Icon ms-Icon--Mail"></i>
      <span>{{ 'sender.sender' | translate }}</span>
      <div class="active-indicator" *ngIf="selectedTabIndex === TabIndexEnum.SENDER"></div>

    </button>
    <button
      [class.active]="selectedTabIndex === TabIndexEnum.LINKS"
      (click)="selectTab(TabIndexEnum.LINKS)">
      <i class="ms-Icon ms-Icon--Link"></i>
      <span>{{ 'links.links' | translate }}</span>
      <div class="active-indicator" *ngIf="selectedTabIndex === TabIndexEnum.LINKS"></div>

    </button>
    <button
      [class.active]="selectedTabIndex === TabIndexEnum.ATTACHMENTS"
      (click)="selectTab(TabIndexEnum.ATTACHMENTS)">
      <i class="ms-Icon ms-Icon--Attach"></i>
      <span>{{ 'attachments.attachments' | translate }}</span>
      <div class="active-indicator" *ngIf="selectedTabIndex === TabIndexEnum.ATTACHMENTS"></div>

    </button>
  </div>

  <div class="burger-container d-flex">

    <div class="burger-icon ms-2" (click)="toggleMenu()">
      <i class="ms-Icon ms-Icon--Settings" style="font-weight:600; font-size:large"></i>
    </div>

    <div class="tab-title">
      <span>{{ currentTabTitle }}</span>
    </div>

    <!-- language selector -->
    <div *ngIf="enableLocalization()">
      <button mat-button [matMenuTriggerFor]="languageMenu">
        <img [src]="languages.get(currentLang).flagUrl" [alt]="currentLang" width="20" height="14" />
        <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5z" fill="currentColor" />
        </svg>
      </button>

      <mat-menu #languageMenu="matMenu">
        <button mat-menu-item *ngFor="let lang of languages | keyvalue" (click)="changeLanguage(lang.key)">
          <img [src]="lang.value.flagUrl" [alt]="lang.value.label" width="20" height="14" style="margin-right: 8px;" />
          {{ lang.value.label }}
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="overlay-menu" *ngIf="menuOpen" [ngClass]="{'adjusted': isBuildVersion}">
    <div class="menu-item" (click)="selectTab(TabIndexEnum.TRUSTED_DOMAINS)">
      <i class="ms-Icon ms-Icon--Shield"></i>
      <span>{{ 'trusted_domains.trusted' | translate }}</span>
    </div>
    <div class="menu-item" (click)="selectTab(TabIndexEnum.CONTENT)">
      <i class="ms-Icon ms-Icon--SkypeMessage"></i>
      <span>{{ 'content.content' | translate }}</span>
    </div>
    <div class="menu-item" (click)="selectTab(TabIndexEnum.LOGS)">
      <i class="ms-Icon ms-Icon--Code"></i>
      <span>{{ 'logs.logs' | translate }}</span>
    </div>
    <div class="menu-item" (click)="selectTab(TabIndexEnum.TERMS_AND_CONDITIONS)">
      <i class="ms-Icon ms-Icon--ClipboardList"></i>
      <span class="text-center">
          {{ 'terms_and_conditions.terms_and_conditions_tab' | translate }}
      </span>
    </div>

  </div>
</div>

<div class="header-divider"></div>

<!-- Overlay Menu -->


<main [ngClass]="{'h-99': !showError}" *ngIf="!isRunning" style="position: relative; word-wrap: anywhere;">

  <!-- Content Area -->
  <div *ngIf="!showError">
    <div *ngIf="!isAnalyzing && runs.current?.incomplete" class="analysis-notice" role="status">
      <strong>{{ 'analysis.incomplete' | translate }}</strong>
      <p>{{ 'analysis.partial_results' | translate }}</p>
      <ul>
        <li *ngFor="let flow of incompleteFlows">{{ ('analysis.flows.' + flow) | translate }}</li>
      </ul>
      <button type="button" class="analysis-retry" (click)="retryAnalysis()">{{ 'analysis.retry' | translate }}</button>
    </div>
    <app-overview
      [verdictAvailable]="!isAnalyzing && runs.current?.verdictAvailable"
      [needleValue]="evaluatorService.needleValue"
      [overviewMap]="riskService.getOverviewMap()"
      [evaluationScore]="riskService.evaluatorsScoreMap"
      [hidden]="selectedTabIndex !== TabIndexEnum.OVERVIEW">
    </app-overview>

    <app-sender
      [senderResult]="assessment?.getAnalysisResultByName(EvaluationFlowsEnum.SENDER)"
      [isRetrievingAge]="isRetrievingAge"
      [riskResult]="assessment?.getAnalysisResultByName(EvaluationFlowsEnum.IMPERSONATION_RISK)"
      [hidden]="selectedTabIndex !== TabIndexEnum.SENDER">
    </app-sender>

    <app-links
      [linksIncomplete]="runs.current?.flows.get(EvaluationFlowsEnum.LINKS)?.state === 'incomplete'"
      [qrIncomplete]="runs.current?.flows.get(EvaluationFlowsEnum.QRCODE)?.state === 'incomplete'"
      [linksResult]="assessment?.getAnalysisResultListByName(EvaluationFlowsEnum.LINKS)"
      [qrResult]="assessment?.getAnalysisResultListByName(EvaluationFlowsEnum.QRCODE)"
      [hidden]="selectedTabIndex !== TabIndexEnum.LINKS">
    </app-links>

    <app-attachment
      [incomplete]="runs.current?.flows.get(EvaluationFlowsEnum.ATTACHMENTS)?.state === 'incomplete'"
      [attachmentsResult]="assessment?.getAnalysisResultListByName(EvaluationFlowsEnum.ATTACHMENTS)"
      [hidden]="selectedTabIndex !== TabIndexEnum.ATTACHMENTS">
    </app-attachment>

    <app-trusted-domains
      [hidden]="selectedTabIndex !== TabIndexEnum.TRUSTED_DOMAINS">
    </app-trusted-domains>

    <app-content
      [hidden]="selectedTabIndex !== TabIndexEnum.CONTENT">
    </app-content>

    <app-logs
      [logsArr]="logService.getLogs()"
      [hidden]="selectedTabIndex !== TabIndexEnum.LOGS">
    </app-logs>
    <app-terms-and-conditions
      [hidden]="selectedTabIndex !== TabIndexEnum.TERMS_AND_CONDITIONS">
    </app-terms-and-conditions>
  </div>


  <ng-container *ngIf="showError">
    <ng-container *ngTemplateOutlet="ifError"></ng-container>
    <button type="button" class="analysis-retry m-4" (click)="retryAnalysis()">{{ 'analysis.retry' | translate }}</button>
  </ng-container>

  <ng-container>
    <ng-container *ngTemplateOutlet="version"></ng-container>
  </ng-container>
</main>

<ng-template #ifError>
  <div *ngIf="errorMessage == HttpErrorsEnum.UNKNOWN_CUSTOMER" class="m-4 mt-5 text-center">
    <h3>{{ 'shared.no_license_detected' | translate }}</h3>
    <p class="mt-3">
      {{ 'shared.contact_your_admin' | translate }}
    </p>

    <p>
      {{ 'shared.visit_website_to_purchase_license' | translate }}
    </p>
    <p class="mt-3">
      <a href="https://pulsarsecurity.com/addin">
        https://pulsarsecurity.com/addin
      </a>
    </p>
  </div>

  <div [ngSwitch]="errorMessage" class="m-4 mt-5 text-center">
    <div *ngSwitchCase="HttpErrorsEnum.AUTHENTICATION_REQUIRED">
      <h3>{{ 'shared.could_not_authenticate' | translate }}</h3>
      <p class="mt-3">
        {{ 'shared.usable_with_outlook_related_domains' | translate }}
      </p>
    </div>

    <div *ngSwitchCase="HttpErrorsEnum.CANT_LOGIN">
      <h3>{{ 'shared.could_not_authenticate' | translate }}</h3>
      <p class="mt-3">
        {{ 'shared.failed_to_login' | translate }}
      </p>
    </div>

    <div *ngSwitchCase="HttpErrorsEnum.POPUP_DISABLED">
      <h3>{{ 'shared.could_not_authenticate' | translate }}</h3>
      <p class="mt-3">
        {{ 'shared.popup_disabled' | translate }}
      </p>
    </div>

    <div *ngSwitchCase="HttpErrorsEnum.FAILED_TO_FETCH_DATA">
      <h3>{{ 'shared.failed_to_start_addin' | translate }}</h3>
      <span class="mt-3">
        {{ 'shared.error_happened_while_loading_data' | translate }}
      </span>
      <span>
        {{ 'shared.please_try_again_later' | translate }}
      </span>
    </div>

    <div *ngSwitchCase="HttpErrorsEnum.GENERAL_ERROR || errorMessage == HttpErrorsEnum.TOKEN_EXPIRED">
      <h3>{{ 'shared.failed_to_start_addin' | translate }}</h3>
      <p class="mt-3">
        {{ 'shared.error_while_starting_addin' | translate }}
      </p>
    </div>
  </div>

</ng-template>

<ng-template #version>
  <div *ngIf="!isRunning && !showError && user?.terms_acceptance_required && selectedTabIndex === TabIndexEnum.OVERVIEW"
       class="bottom-sticky-container" style="bottom: 1.8rem !important;">
    <div class="box-container" style="margin: 0 20px; border-color: #D41516 !important;">
      <div class="box-header">
        <span>{{ 'overview.action_required' | translate }}</span>
      </div>
      <div class="box-item">
        <span>{{ 'overview.accept_terms_requested' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="bottom-sticky-container" *ngIf="env.version != 'BUILD_VERSION'" style="height:1.7rem; z-index: 102;">
    <a target="_blank" href="https://pulsarsecurity.com">{{ env.version }}</a>
    <a target="" style="cursor: pointer;" (click)="selectTab(TabIndexEnum.TERMS_AND_CONDITIONS)"
       *ngIf="!isRunning && !showError">
      {{ 'terms_and_conditions.terms_and_conditions_tab' | translate }}
    </a>
  </div>
</ng-template>
